<div
  *ngIf="open"
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 px-4"
  role="dialog"
  aria-modal="true"
  aria-labelledby="bug-report-title"
  (click)="cancel()"
  (keydown.escape)="cancel()"
>
  <div class="w-full max-w-lg overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl" (click)="$event.stopPropagation()">
    <form (ngSubmit)="submit()" novalidate>
      <div class="flex items-start gap-3 px-6 py-5">
        <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-violet-100">
          <lucide-icon name="bug" [size]="18" class="text-violet-600" [strokeWidth]="2"></lucide-icon>
        </div>
        <div class="min-w-0 flex-1">
          <h3 id="bug-report-title" class="text-sm font-semibold text-slate-900">Report a bug</h3>
          <p class="mt-1 text-sm text-slate-500">
            Tell us what happened and what you expected instead. We read every report.
          </p>

          <!-- Error banner -->
          <div *ngIf="error" class="mt-4 flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
            <lucide-icon name="triangle-alert" [size]="15" class="mt-0.5 flex-shrink-0 text-red-500" [strokeWidth]="2"></lucide-icon>
            <p class="text-sm text-red-700">{{ error }}</p>
          </div>

          <label for="bug-description" class="mb-1.5 mt-4 block text-xs font-medium text-slate-700">What went wrong?</label>
          <textarea
            id="bug-description"
            name="description"
            [(ngModel)]="description"
            [maxlength]="maxLength"
            rows="6"
            placeholder="e.g. I connected a second AWS account and the Lambda page kept loading forever."
            class="block w-full resize-y rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-100 transition-shadow"
          ></textarea>
          <div class="mt-1.5 flex items-start justify-between gap-3 text-xs text-slate-400">
            <span>We'll include the page you're on (<span class="font-mono text-slate-500">{{ pageUrl }}</span>), your browser and window size.</span>
            <span class="flex-shrink-0">{{ description.length }}/{{ maxLength }}</span>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end gap-2 border-t border-slate-200 bg-slate-50 px-6 py-3">
        <button
          type="button"
          (click)="cancel()"
          [disabled]="submitting"
          class="rounded-lg border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
        >
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="submitting"
          class="flex items-center gap-2 rounded-lg bg-violet-600 px-3.5 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <lucide-icon *ngIf="submitting" name="loader" [size]="14" class="animate-spin" [strokeWidth]="2.5"></lucide-icon>
          {{ submitting ? 'Sending...' : 'Send report' }}
        </button>
      </div>
    </form>
  </div>
</div>
